export const fetchPersonalLeaderboards3 = async (data) => {
  const response = await fetch(
    "https://ap.tft.tools/leaderboards/personal-leaderboards",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );
  return response.json();
};

export const createBookmarkLeaderboards = async (title, summoners) => {
  const response = await fetch("https://ap.tft.tools/leaderboards/custom", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      title,
      summoners,
    }),
  });
  const json = await response.json();
  return json.key;
};
